import { css } from "@emotion/css";
import { Avatar } from "@octopusdeploy/design-system-octopus-components";
import { borderRadius, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import type { ReactNode } from "react";
interface TemplateBannerProps {
    iconLink: string | undefined;
    heading: string;
    subHeading: ReactNode;
    accessories?: ReactNode;
}
export function TemplateBanner({ iconLink, heading, subHeading, accessories }: TemplateBannerProps): ReactNode {
    return (<div className={styles.templateInfoContainer}>
            <Avatar type="template" size="medium" src={iconLink} alt="template icon"/>
            <div className={styles.innerContainer}>
                <div className={styles.templateDetails}>
                    <div className={styles.heading}>{heading}</div>
                    <div className={styles.subHeading}>{subHeading}</div>
                </div>
                {accessories}
            </div>
        </div>);
}
const styles = {
    templateInfoContainer: css({
        display: "flex",
        alignItems: "center",
        gap: space[12],
        backgroundColor: themeTokens.color.background.secondary.default,
        borderRadius: borderRadius.small,
        border: `1px solid ${themeTokens.color.border.primary}`,
        padding: space[12],
    }),
    templateDetails: css({
        display: "flex",
        flexDirection: "column",
        flex: 1,
    }),
    heading: css({
        font: text.body.bold.medium,
        color: themeTokens.color.text.primary,
    }),
    subHeading: css({
        font: text.body.regular.small,
        color: themeTokens.color.text.secondary,
    }),
    innerContainer: css({
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "space-between",
    }),
};
